<template>
  <form id="jeSuisPage" method="post">
    <div
      v-if="submitted && erreursGlobales.length != 0"
      class="alert alert-danger text-left global-errors erreur-globale mt-5"
    >
      <p v-for="erreur in erreursGlobales" :key="erreur.index">
        {{ erreur }}
      </p>
    </div>

    <div
      v-if="erreurGlobale != null"
      class="alert alert-danger text-left global-errors erreur-globale mt-5"
    >
      <p>
        {{ erreurGlobale }}
      </p>
    </div>

    <div class="row je-suis-class">
      <div class="col-lg-4 offset-lg-1 photo-field">
        <div class="row d-flex justify-content-center photo-img-row">
          <file-upload
            ref="upload"
            class="photo-upload"
            accept="image/png,image/jpg,image/jpeg"
            @input="photoChanged"
            ><img
              class="photo-img"
              style="cursor: pointer"
              :src="[
                preinscription_out.data.document.documentPhoto.data != null
                  ? 'data:image/gif;base64,' +
                    preinscription_out.data.document.documentPhoto.data
                  : require('@/assets/preinscription_photo.png')
              ]"
            />
          </file-upload>
        </div>
        <p class="photo-text1 d-flex justify-content-center">
          {{ "preinscription_photo_text_1" | translate(locale) }}
        </p>
        <p class="photo-text2 d-flex justify-content-center">
          {{ "preinscription_photo_text_4" | translate(locale) }}
        </p>
        <p class="photo-text2 d-flex justify-content-center">
          <span
            v-html="
              $options.filters.translate('preinscription_photo_text_5', 'fr')
            "
          ></span>
        </p>
        <p class="photo-text2 d-flex justify-content-center">
          {{ "preinscription_photo_text_2" | translate(locale) }}
        </p>
        <p class="photo-text3 d-flex justify-content-center">
          {{ "preinscription_photo_text_3" | translate(locale) }}
        </p>
        <file-upload
          ref="upload"
          accept="image/png,image/jpg,image/jpeg"
          @input="photoChanged"
          >{{ "preinscription_photo_bouton_modifier" | translate(locale) }}
        </file-upload>
      </div>
      <div class="col-lg-5 offset-lg-1">
        <div class="row title">
          {{ "preinscription_titre_civilite" | translate(locale) }}
        </div>
        <div class="row mt-4">
          <!-- Prénom -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label for="preinscription_prenom" class="label"
                >{{ "preinscription_prenom" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (1)</span
                >
              </label>
              <div id="preinscription_prenom" class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.prenom.$error ? 'is-invalid' : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.prenom"
                  :maxlength="60"
                />
              </div>
              <div
                v-if="submitted && !$v.preinscription_out.data.prenom.required"
                class="invalid-form"
              >
                {{ "preinscription_prenom_requis" | translate(locale) }}
              </div>
              <div
                v-if="submitted && !$v.preinscription_out.data.prenom.maxLength"
                class="invalid-form"
              >
                {{ "preinscription_prenom_maxLength" | translate(locale) }}
              </div>
            </div>
          </div>
          <!-- Nom -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_nom" | translate(locale)
                }}<span style="color: #dc3545;"> *</span></label
              >
              <div class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.nom.$error ? 'is-invalid' : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.nom"
                  :maxlength="60"
                />
              </div>
              <div
                v-if="submitted && !$v.preinscription_out.data.nom.required"
                class="invalid-form"
              >
                {{ "preinscription_nom_requis" | translate(locale) }}
              </div>
              <div
                v-if="submitted && !$v.preinscription_out.data.nom.maxLength"
                class="invalid-form"
              >
                {{ "preinscription_nom_maxLength" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Sexe -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_sexe" | translate(locale)
                }}<span style="color: #dc3545;"> *</span></label
              >
              <div class="control-sexe">
                <v-select
                  :class="[
                    $v.preinscription_out.data.sexe.$error ? 'is-invalid' : ''
                  ]"
                  :options="sexeList"
                  label="libelle"
                  :clearable="false"
                  v-model="preinscription_out.data.sexe"
                  :get-option-label="getSexeLibelle"
                >
                  <span slot="no-options">{{
                    "list_no_result" | translate(locale)
                  }}</span>
                </v-select>
              </div>
              <div
                v-if="submitted && !$v.preinscription_out.data.sexe.required"
                class="invalid-form"
              >
                {{ "preinscription_sexe_requis" | translate(locale) }}
              </div>
            </div>
          </div>
          <!-- Nom de naissance -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label for="preinscription_nom_naissance" class="label"
                >{{ "preinscription_nom_naissance" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (2)</span
                ></label
              >
              <div id="preinscription_nom_naissance" class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.nomNaissance.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.nomNaissance"
                  :maxlength="60"
                />
              </div>
              <div
                v-if="
                  submitted && !$v.preinscription_out.data.nomNaissance.required
                "
                class="invalid-form"
              >
                {{ "preinscription_nom_naissance_requis" | translate(locale) }}
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.nomNaissance.maxLength
                "
                class="invalid-form"
              >
                {{
                  "preinscription_nomNaissance_maxLength" | translate(locale)
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6"></div>
          <div class="col-lg-6 col-md-6 nomNaissanceCheck">
            <label class="mes-justificatifs-text">
              <input
                type="checkbox"
                class="modal-check-label"
                v-model="nomNaissanceCheck"
              />
              {{
                "preinscription_nom_naissance_identique" | translate("fr")
              }}</label
            >
          </div>
        </div>
        <div class="row">
          <!-- Nationalité -->
          <div v-if="getAge() >= 18" class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_nationalite" | translate(locale)
                }}<span style="color: #dc3545;"> *</span></label
              >
              <div class="control-nationalite">
                <v-select
                  :class="[
                    $v.preinscription_out.data.generalite.nationalite.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  :options="nationaliteList"
                  label="libelle"
                  :clearable="false"
                  :disabled="
                    preinscription.data.generalite.nationalite.libelle ===
                      null ||
                    preinscription.data.generalite.nationalite.libelle === ''
                      ? false
                      : true
                  "
                  v-model="preinscription_out.data.generalite.nationalite"
                >
                  <span slot="no-options">{{
                    "list_no_result" | translate(locale)
                  }}</span>
                </v-select>
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.generalite.nationalite.code
                      .required &&
                    !$v.preinscription_out.data.generalite.nationalite.libelle
                      .required
                "
                class="invalid-form"
              >
                {{ "preinscription_nationalite_requis" | translate(locale) }}
              </div>
            </div>
          </div>
          <!-- Taille en cm -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group form-group-taille">
              <label class="label"
                >{{ "preinscription_taille" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (3)</span
                ></label
              >
              <div class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.informationMedicale.taille.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.informationMedicale.taille"
                />
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.informationMedicale.taille
                      .required
                "
                class="invalid-form"
              >
                {{ "preinscription_taille_requis" | translate(locale) }}
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.informationMedicale.taille
                      .between
                "
                class="invalid-form"
              >
                {{ "preinscription_taille_invalid" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Né(e) le -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group form-group-ne">
              <label class="label"
                >{{ "preinscription_date_naissance" | translate(locale)
                }}<span style="color: #dc3545;"> *</span></label
              >
              <div class="control">
                <datepicker
                  :language="fr"
                  input-class="vue-date-picker"
                  format="dd/MM/yyyy"
                  :disabled="true"
                  v-model="preinscription_out.data.dateNaissance"
                  @input="formatDatepicker()"
                ></datepicker>
              </div>
            </div>
          </div>
          <!-- Ville de naissance -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_ville_naissance" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (4)</span
                ></label
              >
              <div class="control-villes">
                <vue-bootstrap-typeahead
                  :data="villesNaissance"
                  v-model="rechercheVilleNaissance"
                  :max-matches="100"
                  :serializer="s => s.codePostal + ' - ' + s.libelle"
                  @hit="
                    preinscription_out.data.generalite.communeNaissance = $event
                  "
                  @input="
                    {
                      preinscription_out.data.generalite.communeNaissance.libelle = $event;
                      preinscription_out.data.generalite.communeNaissance.codePostal = null;
                      preinscription_out.data.generalite.communeNaissance.id = null;
                    }
                  "
                  ref="villeNaissanceTypeahead"
                  :show-all="true"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Ville de naissance à l'étranger -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{
                  "preinscription_ville_naissance_etranger" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (4)</span
                ></label
              >
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="
                    preinscription_out.data.generalite.villeEtrangereNaissance
                  "
                />
              </div>
            </div>
          </div>
          <!-- Pays de naissance à l'étranger -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{
                  "preinscription_pays_naissance_etranger" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (4)</span
                ></label
              >
              <div class="control-nationalite-etrangere">
                <v-select
                  :options="paysEtrangersList"
                  label="libelle"
                  :clearable="false"
                  v-model="
                    preinscription_out.data.generalite.nationaliteNaissance
                  "
                >
                  <span slot="no-options">{{
                    "list_no_result" | translate(locale)
                  }}</span>
                </v-select>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-if="
            getAge() >= 18 &&
              preinscription_out.data.generalite.nationaliteNaissance.code !=
                null &&
              preinscription_out.data.generalite.nationaliteNaissance.code !=
                'FRA'
          "
        >
          <!-- Prénom mère -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label for="preinscription_prenom_mere" class="label"
                >{{ "preinscription_prenom_mere" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (5)</span
                ></label
              >
              <div id="preinscription_prenom_mere" class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.prenomMere.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.prenomMere"
                  :maxlength="60"
                />
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.prenomMere.isLengthMaxNomParent
                "
                class="invalid-form"
              >
                {{ "preinscription_prenomMere_maxLength" | translate(locale) }}
              </div>
            </div>
          </div>

          <!-- Nom mère -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label for="preinscription_nom_mere" class="label"
                >{{ "preinscription_nom_mere" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (5)</span
                ></label
              >
              <div id="preinscription_nom_mere" class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.nomMere.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.nomMere"
                  :maxlength="60"
                />
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.nomMere.isLengthMaxNomParent
                "
                class="invalid-form"
              >
                {{ "preinscription_nomMere_maxLength" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-if="
            getAge() >= 18 &&
              preinscription_out.data.generalite.nationaliteNaissance.code !=
                null &&
              preinscription_out.data.generalite.nationaliteNaissance.code !=
                'FRA'
          "
        >
          <!-- Prénom père -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label for="preinscription_prenom_pere" class="label"
                >{{ "preinscription_prenom_pere" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (5)</span
                ></label
              >
              <div id="preinscription_prenom_pere" class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.prenomPere.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.prenomPere"
                  :maxlength="60"
                />
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.prenomPere.isLengthMaxNomParent
                "
                class="invalid-form"
              >
                {{ "preinscription_prenomPere_maxLength" | translate(locale) }}
              </div>
            </div>
          </div>

          <!-- Nom père -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label for="preinscription_nom_pere" class="label"
                >{{ "preinscription_nom_pere" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (5)</span
                ></label
              >
              <div id="preinscription_nom_pere" class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.nomPere.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.nomPere"
                  :maxlength="60"
                />
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.nomPere.isLengthMaxNomParent
                "
                class="invalid-form"
              >
                {{ "preinscription_nomPere_maxLength" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>

        <br />
        <p class="je-suis-text-info mb-0" style="color: #dc3545;">
          {{ "champs_obligatoires_1" | translate(locale) }}
        </p>
        <p
          v-if="
            getAge() >= 18 &&
              preinscription_out.data.generalite.nationaliteNaissance.code !=
                null &&
              preinscription_out.data.generalite.nationaliteNaissance.code !=
                'FRA'
          "
          class="je-suis-text-info mb-0"
          style="color: #dc3545;"
        >
          {{ "mentions_facultatives_nom_prenom_mere_pere" | translate(locale) }}
        </p>

        <br />

        <div class="row title">
          {{ "preinscription_titre_adresse" | translate(locale) }}
        </div>
        <div class="row mt-4">
          <!-- Rue -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label">{{
                "preinscription_adresse_rue" | translate(locale)
              }}</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="preinscription_out.data.generalite.rue"
                />
              </div>
            </div>
          </div>
          <!-- Complément d’adresse -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label">{{
                "preinscription_adresse_complement" | translate(locale)
              }}</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="preinscription_out.data.generalite.complementRue"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <!-- Pays -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_adresse_pays" | translate(locale)
                }}<span style="color: #dc3545;"> *</span></label
              >
              <div class="control-pays">
                <v-select
                  :class="[
                    $v.preinscription_out.data.generalite.nationaliteAdresse
                      .code.$error
                      ? 'is-invalid'
                      : $v.preinscription_out.data.generalite.nationaliteAdresse
                          .libelle.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  :options="paysList"
                  label="libelle"
                  :clearable="false"
                  v-model="
                    preinscription_out.data.generalite.nationaliteAdresse
                  "
                >
                  <span slot="no-options">{{
                    "list_no_result" | translate(locale)
                  }}</span>
                </v-select>
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.generalite.nationaliteAdresse
                      .code.required &&
                    !$v.preinscription_out.data.generalite.nationaliteAdresse
                      .libelle.required
                "
                class="invalid-form"
              >
                {{ "preinscription_adresse_pays_requis" | translate(locale) }}
              </div>
            </div>
          </div>
          <!-- Ville -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_adresse_ville" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (6)</span
                ></label
              >
              <div class="control-villes">
                <vue-bootstrap-typeahead
                  :class="[
                    $v.preinscription_out.data.generalite.communeVille.id.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  :data="villes"
                  v-model="rechercheVille"
                  :max-matches="100"
                  :serializer="s => s.codePostal + ' - ' + s.libelle"
                  @hit="
                    preinscription_out.data.generalite.communeVille = $event
                  "
                  @input="
                    {
                      preinscription_out.data.generalite.communeVille.libelle = $event;
                      preinscription_out.data.generalite.communeVille.codePostal = null;
                      preinscription_out.data.generalite.communeVille.id = null;
                    }
                  "
                  ref="villeTypeahead"
                  :show-all="true"
                />
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.generalite.communeVille.id
                      .required
                "
                class="invalid-form"
              >
                {{ "preinscription_adresse_ville_requis" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="
            preinscription_out.data.generalite.nationaliteAdresse.code !=
              null &&
              preinscription_out.data.generalite.nationaliteAdresse.code !=
                'FRA'
          "
        >
          <!-- Ville étrangère -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_ville_etranger" | translate(locale)
                }}<span class="je-suis-text-info" style="color: #dc3545;">
                  (6)</span
                ></label
              >
              <div class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.generalite.villeEtrangere.$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.generalite.villeEtrangere"
                />
              </div>
              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.generalite.villeEtrangere
                      .required
                "
                class="invalid-form"
              >
                {{ "preinscription_ville_etranger_requis" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>
        <br />
        <p class="je-suis-text-info" style="color: #dc3545;">
          {{ "champs_obligatoires_6" | translate(locale) }}
        </p>
        <div class="row title">
          {{ "preinscription_titre_contact" | translate(locale) }}
        </div>
        <div class="row mt-4">
          <!-- E-mail -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label"
                >{{ "preinscription_mail" | translate(locale)
                }}<span style="color: #dc3545;"> *</span></label
              >
              <div class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.mail.$error ? 'is-invalid' : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.mail"
                />
              </div>
              <div
                v-if="submitted && !$v.preinscription_out.data.mail.required"
                class="invalid-form"
              >
                {{ "preinscription_mail_requis" | translate(locale) }}
              </div>
              <div
                v-if="submitted && !$v.preinscription_out.data.mail.email"
                class="invalid-form"
              >
                {{ "preinscription_mail_invalid" | translate(locale) }}
              </div>
            </div>
          </div>
          <!-- Tel. domicile -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label">{{
                "preinscription_tel_domicile" | translate(locale)
              }}</label>
              <div class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.generalite.telephoneDomicile
                      .$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.generalite.telephoneDomicile"
                />
              </div>

              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.generalite.telephoneDomicile
                      .isPhoneValid
                "
                class="invalid-form"
              >
                {{ "preinscription_tel_invalid" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <!-- Tel. portable -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label class="label">{{
                "preinscription_tel_portable" | translate(locale)
              }}</label>
              <div class="control">
                <input
                  :class="[
                    'input',
                    $v.preinscription_out.data.generalite.telephonePortable
                      .$error
                      ? 'is-invalid'
                      : ''
                  ]"
                  type="text"
                  v-model="preinscription_out.data.generalite.telephonePortable"
                />
              </div>

              <div
                v-if="
                  submitted &&
                    !$v.preinscription_out.data.generalite.telephonePortable
                      .isPhoneValid
                "
                class="invalid-form"
              >
                {{ "preinscription_tel_invalid" | translate(locale) }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="getAge() < 18">
          <div class="row">
            <!-- Prénom représentant légal 1 -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label
                  for="preinscription_prenom_pere_representant_legal"
                  class="label"
                  >{{
                    "preinscription_prenom_pere_representant_legal"
                      | translate(locale)
                  }}<span style="color: #dc3545;"> *</span></label
                >
                <div
                  id="preinscription_prenom_pere_representant_legal"
                  class="control"
                >
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.prenomPere.$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="preinscription_out.data.prenomPere"
                    :maxlength="60"
                  />
                </div>
                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.prenomPere
                        .isLengthMaxNomParent
                  "
                  class="invalid-form"
                >
                  {{
                    "preinscription_prenomPere_representant_legal_maxLength"
                      | translate(locale)
                  }}
                </div>
              </div>
            </div>

            <!-- Nom représentant légal 1 -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label
                  for="preinscription_nom_pere_representant_legal"
                  class="label"
                  >{{
                    "preinscription_nom_pere_representant_legal"
                      | translate(locale)
                  }}<span style="color: #dc3545;"> *</span></label
                >
                <div
                  id="preinscription_nom_pere_representant_legal"
                  class="control"
                >
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.nomPere.$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="preinscription_out.data.nomPere"
                    :maxlength="60"
                  />
                </div>
                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.nomPere.isLengthMaxNomParent
                  "
                  class="invalid-form"
                >
                  {{
                    "preinscription_nomPere_representant_legal_maxLength"
                      | translate(locale)
                  }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Téléphone père -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label class="label">{{
                  "preinscription_tel_pere" | translate(locale)
                }}</label>
                <div class="control">
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.generalite.telephoneMineurPere
                        .$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="
                      preinscription_out.data.generalite.telephoneMineurPere
                    "
                  />
                </div>

                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.generalite.telephoneMineurPere
                        .isLegalReprPhoneValid
                  "
                  class="invalid-form"
                >
                  {{ "preinscription_tel_invalid" | translate(locale) }}
                </div>
              </div>
            </div>

            <!-- Adresse e-mail père -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label class="label"
                  >{{ "preinscription_mail_pere" | translate(locale)
                  }}<span style="color: #dc3545;"> *</span></label
                >
                <div class="control">
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.generalite.mailMineurPere
                        .$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="preinscription_out.data.generalite.mailMineurPere"
                  />
                </div>
                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.generalite.mailMineurPere
                        .isLegalReprEmailValid
                  "
                  class="invalid-form"
                >
                  {{ "preinscription_mail_pere_invalid" | translate(locale) }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Prénom représentant légal 2 -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label
                  for="preinscription_prenom_mere_representant_legal"
                  class="label"
                  >{{
                    "preinscription_prenom_mere_representant_legal"
                      | translate(locale)
                  }}</label
                >
                <div
                  id="preinscription_prenom_mere_representant_legal"
                  class="control"
                >
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.prenomMere.$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="preinscription_out.data.prenomMere"
                    :maxlength="60"
                  />
                </div>
                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.prenomMere
                        .isLengthMaxNomParent
                  "
                  class="invalid-form"
                >
                  {{
                    "preinscription_prenomMere_representant_legal_maxLength"
                      | translate(locale)
                  }}
                </div>
              </div>
            </div>

            <!-- Nom représentant légal 2 -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label
                  for="preinscription_nom_mere_representant_legal"
                  class="label"
                  >{{
                    "preinscription_nom_mere_representant_legal"
                      | translate(locale)
                  }}</label
                >
                <div
                  id="preinscription_nom_mere_representant_legal"
                  class="control"
                >
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.nomMere.$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="preinscription_out.data.nomMere"
                    :maxlength="60"
                  />
                </div>
                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.nomMere.isLengthMaxNomParent
                  "
                  class="invalid-form"
                >
                  {{
                    "preinscription_nomMere_representant_legal_maxLength"
                      | translate(locale)
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Téléphone mère -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label class="label">{{
                  "preinscription_tel_mere" | translate(locale)
                }}</label>
                <div class="control">
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.generalite.telephoneMineurMere
                        .$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="
                      preinscription_out.data.generalite.telephoneMineurMere
                    "
                  />
                </div>

                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.generalite.telephoneMineurMere
                        .isLegalReprPhoneValid
                  "
                  class="invalid-form"
                >
                  {{ "preinscription_tel_invalid" | translate(locale) }}
                </div>
              </div>
            </div>

            <!-- Adresse e-mail mère -->
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label class="label">{{
                  "preinscription_mail_mere" | translate(locale)
                }}</label>
                <div class="control">
                  <input
                    :class="[
                      'input',
                      $v.preinscription_out.data.generalite.mailMineurMere
                        .$error
                        ? 'is-invalid'
                        : ''
                    ]"
                    type="text"
                    v-model="preinscription_out.data.generalite.mailMineurMere"
                  />
                </div>
                <div
                  v-if="
                    submitted &&
                      !$v.preinscription_out.data.generalite.mailMineurMere
                        .isLegalReprEmailValid
                  "
                  class="invalid-form"
                >
                  {{ "preinscription_mail_mere_invalid" | translate(locale) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="je-suis-text-champs-obligatoires mt-4">
          {{ "champs_obligatoires" | translate(locale) }}
        </p>
        <p class="mt-4 je-suis-text-info">
          <span
            v-html="
              $options.filters.translate(
                'preinscription_je_suis_text_info',
                'fr'
              )
            "
          ></span>
        </p>
      </div>
    </div>

    <div
      v-if="submitted && erreursGlobales.length != 0"
      class="alert alert-danger text-left global-errors erreur-globale mt-5"
    >
      <p v-for="erreur in erreursGlobales" :key="erreur.index">
        {{ erreur }}
      </p>
    </div>

    <div
      v-if="erreurGlobale != null"
      class="alert alert-danger text-left global-errors erreur-globale mt-5"
    >
      <p>
        {{ erreurGlobale }}
      </p>
    </div>
  </form>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  between,
  requiredIf,
  maxLength
} from "vuelidate/lib/validators";
import translations from "@/Translations.js";
import vSelect from "vue-select";
import Datepicker from "@/components/extensions/datepicker/components/Datepicker";
import { fr } from "@/components/extensions/datepicker/locale";
import VueBootstrapTypeahead from "@/components/extensions/VueBootstrapTypeahead.vue";
import FileUpload from "vue-upload-component";

import "vue-select/dist/vue-select.css";

import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import _ from "lodash";

const isPhoneValid = value => {
  value = _.trim(value);
  return (
    // on verifie comme sur FBI
    value === null ||
    value === "" ||
    /^[\\+]?[(]?[0-9 .]{3}[)]?[-\\s\\.]?[0-9 .]{3,5}[-\\s\\.]?[0-9 .]{4,6}$/.test(
      value
    )
  );
};

// valider le numéro de téléphone du représentant légal que pour les personnes mineures (< 18 ans)
const isLegalReprPhoneValid = function(value) {
  value = _.trim(value);
  return this !== undefined && this.getAge() >= 18
    ? true
    : // on verifie comme sur FBI
      value === null ||
        value === "" ||
        /^[\\+]?[(]?[0-9 .]{3}[)]?[-\\s\\.]?[0-9 .]{3,5}[-\\s\\.]?[0-9 .]{4,6}$/.test(
          value
        );
};

// valider l'adresse mail du représentant légal que pour les personnes mineures (< 18 ans)
const isLegalReprEmailValid = function(value) {
  return this !== undefined && this.getAge() >= 18
    ? true
    : value === null ||
        value === "" ||
        /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
          value
        );
};

const isLengthMaxNomParent = function(value) {
  return (this.getAge() >= 18 &&
    this.preinscription_out.data.generalite.nationaliteNaissance.code != null &&
    this.preinscription_out.data.generalite.nationaliteNaissance.code !=
      "FRA") ||
    (this.getAge() > 0 && this.getAge() < 18)
    ? value === null || value === "" || value.length <= 60
    : true;
};

export default {
  components: {
    vSelect,
    Datepicker,
    VueBootstrapTypeahead,
    FileUpload
  },
  mixins: [validationMixin],
  props: {
    preinscription: Object,
    token: undefined,
    clickedNext: Boolean,
    currentStep: Object,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      preinscription_out: Object,
      token_out: undefined,
      submitted: false,
      nomNaissanceCheck: false,
      nationaliteList: [],
      sexeList: ["M", "F"],
      paysList: [],
      paysEtrangersList: [],
      fr: fr,
      villes: [],
      villesNaissance: [],
      rechercheVille: "",
      rechercheVilleNaissance: "",
      erreursGlobales: [],
      erreurGlobale: null // valorisée dans traitementErreursServeur
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  validations: {
    preinscription_out: {
      data: {
        prenom: {
          required,
          maxLength: maxLength(60)
        },
        nom: {
          required,
          maxLength: maxLength(60)
        },
        nomNaissance: {
          required,
          maxLength: maxLength(60)
        },
        sexe: {
          required
        },
        mail: {
          required,
          email
        },
        nomMere: {
          isLengthMaxNomParent
        },
        prenomMere: {
          isLengthMaxNomParent
        },
        nomPere: {
          isLengthMaxNomParent
        },
        prenomPere: {
          isLengthMaxNomParent
        },
        generalite: {
          telephonePortable: {
            isPhoneValid
          },
          telephoneDomicile: {
            isPhoneValid
          },
          telephoneMineurMere: {
            isLegalReprPhoneValid
          },
          telephoneMineurPere: {
            isLegalReprPhoneValid
          },
          // la nationalité n'est obligatoire que pour les personnes majeures (>= 18 ans)
          nationalite: {
            code: {
              required: requiredIf(function() {
                return this.getAge() >= 18;
              })
            },
            libelle: {
              required: requiredIf(function() {
                return this.getAge() >= 18;
              })
            }
          },
          nationaliteAdresse: {
            code: {
              required
            },
            libelle: {
              required
            }
          },
          communeVille: {
            codePostal: {
              required: requiredIf(function() {
                return (
                  this.preinscription_out.data &&
                  this.preinscription_out.data.generalite.nationaliteAdresse
                    .code != null &&
                  this.preinscription_out.data.generalite.nationaliteAdresse
                    .code === "FRA"
                );
              })
            },
            id: {
              required: requiredIf(function() {
                return (
                  this.preinscription_out.data &&
                  this.preinscription_out.data.generalite.nationaliteAdresse
                    .code != null &&
                  this.preinscription_out.data.generalite.nationaliteAdresse
                    .code === "FRA"
                );
              })
            },
            libelle: {
              required: requiredIf(function() {
                return (
                  this.preinscription_out.data &&
                  this.preinscription_out.data.generalite.nationaliteAdresse
                    .code != null &&
                  this.preinscription_out.data.generalite.nationaliteAdresse
                    .code === "FRA"
                );
              })
            }
          },
          villeEtrangere: {
            required: requiredIf(function() {
              return (
                this.preinscription_out.data &&
                this.preinscription_out.data.generalite.nationaliteAdresse
                  .code != null &&
                this.preinscription_out.data.generalite.nationaliteAdresse
                  .code != "FRA"
              );
            })
          },
          mailMineurMere: {
            isLegalReprEmailValid
          },
          mailMineurPere: {
            isLegalReprEmailValid
          }
        },
        informationMedicale: {
          taille: {
            between: between(0, 250),
            // la taille est obligatoire si l'individu à un âge compris entre 10 et 18 ans
            required: requiredIf(function() {
              return this.getAge() >= 10 && this.getAge() <= 18;
            })
          }
        }
      }
    }
  },
  methods: {
    canContinue() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        // la page remonte automatiquement au niveau du premier champ en erreur
        this.$nextTick(() =>
          document.querySelector(".is-invalid").scrollIntoView()
        );

        return;
      }
      // la page remonte automatiquement eu haut si on a des erreurs a la validation de la page
      if (
        (this.erreursGlobales != null && this.erreursGlobales.length > 0) ||
        (this.erreurGlobale != null && this.erreurGlobale.length > 0)
      ) {
        window.scrollTo(0, 0);
      }
    },
    photoChanged(files) {
      if (!files[0]) {
        return;
      }

      // on verifie le format de l'image
      if (
        files[0].type != "image/png" &&
        files[0].type != "image/jpg" &&
        files[0].type != "image/jpeg"
      ) {
        this.erreurGlobale = "Le format de l'image n'est pas accepté";
        // la page remonte automatiquement eu haut dans le cas d'erreur
        window.scrollTo(0, 0);
        return;
      }

      // on tranforme l'image en chaîne base64
      var reader = new FileReader();
      var that = this;
      reader.readAsDataURL(files[0].file);
      reader.addEventListener(
        "load",
        function() {
          var documentData = reader.result.replace(
            /^data:image\/(png|jpg|jpeg);base64,/,
            ""
          );

          if (!documentData) {
            this.erreurGlobale =
              "Une erreur est survenue lors du chargement de la photo";
            // la page remonte automatiquement eu haut dans le cas d'erreur
            window.scrollTo(0, 0);
            return;
          }

          // on crée un objet documentPhoto pour passer au ws putDocument
          var document = {
            documentPhoto: {
              nom: files[0].file.name,
              data: documentData
            }
          };

          that.putDocument(document, false /*isReconnected*/);
        },
        false
      );
    },
    putDocument(document, isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .putDocument(that.token_out, document)
        .then(result => {
          // si l'image a été bien sauvegardée, on met a jour la preinscription avec les informations de l'image
          that.preinscription_out.data.document = result;
          that.preinscription.data.document = result;
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          argsArray.push(document);
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.putDocument,
            argsArray
          );
        });
    },
    getVillesNaissance(libelle, isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getVille(this.token_out, libelle)
        .then(result => {
          if (result != null) {
            that.villesNaissance = result.data;
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          argsArray.push(libelle);
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getVillesNaissance,
            argsArray
          );
        });
    },
    getVilles(libelle, isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getVille(this.token_out, libelle)
        .then(result => {
          if (result != null) {
            that.villes = result.data;
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          argsArray.push(libelle);
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getVilles,
            argsArray
          );
        });
    },
    getNationaliteAndPaysList(isReconnected) {
      var that = this;

      // de la liste de nationalités/pays générée on garde seulement les champ code et libellé qu'on doit valoriser dans le json en sortie
      preinscriptionAppelsServeur
        .getByName(this.token_out, "Nationalite")
        .then(result => {
          var nationaliteListVisible = result.data.filter(function(
            nationalite
          ) {
            return nationalite.nonVisible == "false";
          });

          var nationaliteListReduced = _.reduce(
            nationaliteListVisible,
            function(results, nationalite) {
              results.push({
                code: nationalite.code,
                libelle: nationalite.libelle
              });

              return results;
            },
            []
          );
          that.nationaliteList = _.uniqBy(
            _.sortBy(nationaliteListReduced, ["libelle"]),
            "code"
          );

          var paysListReduced = _.reduce(
            nationaliteListVisible,
            function(results, pays) {
              results.push({
                code: pays.code,
                libelle: pays.nomPays
              });

              return results;
            },
            []
          );

          that.paysList = [
            {
              code: null,
              libelle: null
            }
          ];
          [].push.apply(
            that.paysList,
            _.uniqBy(_.sortBy(paysListReduced, ["libelle"]), "code")
          );

          // retirer la 'France' de la liste des pays etrangers
          that.paysEtrangersList = JSON.parse(JSON.stringify(that.paysList));
          _.remove(that.paysEtrangersList, function(pays) {
            return pays.code === "FRA";
          });
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getNationaliteAndPaysList,
            argsArray
          );
        });
    },
    getAge() {
      if (!this.preinscription_out.data) {
        return 0;
      }
      var dateNaissance = this.preinscription_out.data.dateNaissance;
      var dateFinSaison = this.preinscription_out.data.saison.fin;
      return preinscriptionAppelsServeur.getAgeLicencie(
        dateNaissance,
        dateFinSaison
      );
    },
    formatDatepicker() {
      var dateNaissance = this.preinscription_out.data.dateNaissance;
      this.preinscription_out.data.dateNaissance = preinscriptionAppelsServeur.formatDateWithoutTime(
        dateNaissance
      );
    },
    getSexeLibelle: function(code) {
      if (code === "F") {
        return "Feminin";
      } else if (code === "M") {
        return "Masculin";
      }
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    },
    $v: {
      handler: function(val) {
        this.erreursGlobales = [];

        if (
          this.preinscription_out.data.document.documentPhoto.id != null &&
          this.preinscription_out.data.document.documentPhoto.data === null
        ) {
          this.erreursGlobales.push("Cette photo n'est pas valide");
        }

        // verifie si la ville de naissance n'est pas saisie
        var villeNaissanceVide =
          this.preinscription_out.data.generalite.communeNaissance.id === null;

        // verifie si l'une de ville/pays de naissance a l'etranger n'est pas saisie
        var villeNaissanceEtrangereVide =
          this.preinscription_out.data.generalite.villeEtrangereNaissance ===
            null ||
          this.preinscription_out.data.generalite.villeEtrangereNaissance ===
            "";
        var paysNaissanceEtrangereVide =
          this.preinscription_out.data.generalite.nationaliteNaissance
            .libelle === null ||
          this.preinscription_out.data.generalite.nationaliteNaissance
            .libelle === "";

        if (
          (villeNaissanceVide &&
            (villeNaissanceEtrangereVide || paysNaissanceEtrangereVide)) ||
          (!villeNaissanceVide &&
            (!villeNaissanceEtrangereVide || !paysNaissanceEtrangereVide))
        ) {
          this.erreursGlobales.push(
            "Si vous êtes nés en France complétez Ville de naissance, si vous êtes nés à l'étranger complétez Ville et Pays de naissance à l'étranger"
          );
        }

        if (
          this.preinscription_out.data.generalite.nationaliteAdresse.code !=
            null &&
          this.preinscription_out.data.generalite.nationaliteAdresse.code ===
            "FRA"
        ) {
          this.preinscription_out.data.generalite.villeEtrangere = null;
        }

        // Rendre obligatoire au moins un des 2 représentants légaux (doivent être au moins saisis Nom/prénom/mail)
        var representantLegal1NotVide =
          this.preinscription_out.data.nomPere != null &&
          this.preinscription_out.data.nomPere != "" &&
          this.preinscription_out.data.prenomPere != null &&
          this.preinscription_out.data.prenomPere != "" &&
          this.preinscription_out.data.generalite.mailMineurPere != null &&
          this.preinscription_out.data.generalite.mailMineurPere != "";
        var representantLegal2NotVide =
          this.preinscription_out.data.nomMere != null &&
          this.preinscription_out.data.nomMere != "" &&
          this.preinscription_out.data.prenomMere != null &&
          this.preinscription_out.data.prenomMere != "" &&
          this.preinscription_out.data.generalite.mailMineurMere != null &&
          this.preinscription_out.data.generalite.mailMineurMere != "";

        if (
          this.getAge() < 18 &&
          !representantLegal1NotVide &&
          !representantLegal2NotVide
        ) {
          this.erreursGlobales.push(
            "Cette préinscription concerne un mineur vous devez saisir au moins le nom/prénom/e-mail d'un des représentants légaux"
          );
        }

        if (!val.$invalid && this.erreursGlobales.length === 0) {
          this.$emit("can-continue", {
            value: true,
            preinscription: this.preinscription_out
          });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true
    },
    clickedNext(val) {
      if (val === true) {
        this.canContinue();
      }
    },
    rechercheVille: _.debounce(function(addr) {
      this.getVilles(addr, false /*isReconnected*/);
    }, 500),
    rechercheVilleNaissance: _.debounce(function(addr) {
      this.getVillesNaissance(addr, false /*isReconnected*/);
    }, 500)
  },
  created() {
    // la clone preinscription_out est utilisé dans le template et il faut l'initialiser avant mounted
    this.preinscription_out = JSON.parse(JSON.stringify(this.preinscription));

    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    // initialisation du champ Ville de naissance
    if (
      this.$refs.villeNaissanceTypeahead &&
      this.preinscription_out.data.generalite.communeNaissance.codePostal !=
        null &&
      this.preinscription_out.data.generalite.communeNaissance.libelle != null
    ) {
      this.$refs.villeNaissanceTypeahead.inputValue =
        this.preinscription_out.data.generalite.communeNaissance.codePostal +
        " - " +
        this.preinscription_out.data.generalite.communeNaissance.libelle;
    }

    if (
      this.$refs.villeTypeahead &&
      this.preinscription_out.data.generalite.communeVille.codePostal != null &&
      this.preinscription_out.data.generalite.communeVille.libelle != null
    ) {
      this.$refs.villeTypeahead.inputValue =
        this.preinscription_out.data.generalite.communeVille.codePostal +
        " - " +
        this.preinscription_out.data.generalite.communeVille.libelle;
    }

    this.getNationaliteAndPaysList(false /*isResonnected*/);
  },
  updated() {
    if (
      this.$refs.villeNaissanceTypeahead &&
      this.preinscription_out.data.generalite.communeNaissance.codePostal !=
        null &&
      this.preinscription_out.data.generalite.communeNaissance.libelle != null
    ) {
      this.$refs.villeNaissanceTypeahead.inputValue =
        this.preinscription_out.data.generalite.communeNaissance.codePostal +
        " - " +
        this.preinscription_out.data.generalite.communeNaissance.libelle;
    }

    if (
      this.$refs.villeTypeahead &&
      this.preinscription_out.data.generalite.communeVille.codePostal != null &&
      this.preinscription_out.data.generalite.communeVille.libelle != null
    ) {
      this.$refs.villeTypeahead.inputValue =
        this.preinscription_out.data.generalite.communeVille.codePostal +
        " - " +
        this.preinscription_out.data.generalite.communeVille.libelle;
    }

    if (this.nomNaissanceCheck) {
      this.preinscription_out.data.nomNaissance = this.preinscription_out.data.nom;
    }
  }
};
</script>

<style scoped>
.form-group {
  font-family: Lato;
  font-size: 14px;
  text-align: left;
}

label {
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-bottom: 0;
}

.form-group .is-invalid {
  border-color: #dc3545;
}

.form-group .is-invalid:focus,
.control:focus {
  outline-color: #dc3545;
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.input {
  width: 100%;
  height: 41px;
  border: solid 1px #6c757d2b;
  padding: 0 10px;
}

.photo-field {
  border: solid 1px #f0f0f1;
  background-color: #d8d8d83d;
}

.photo-text1 {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  margin-top: 40px;
}

.photo-text2,
.photo-text3,
.invalid-photo {
  font-family: Lato;
  font-size: 16px;
  margin-bottom: 5px;
  color: #000000b0;
}

.invalid-photo {
  margin-top: 20px;
  color: #dc3545;
}

.photo-field label {
  display: block;
  padding-left: 50px;
  text-indent: -50px;
}

.photo-field label input {
  vertical-align: bottom;
  margin-right: 10px;
}

.photo-upload label {
  cursor: default;
}

.je-suis-text-info {
  text-align: left;
  font-family: Lato;
  font-size: 9px;
  line-height: 17px;
  color: #000000;
  white-space: pre-line;
}

.je-suis-text-champs-obligatoires {
  text-align: left;
  font-family: Lato;
  font-size: 16px;
  color: #dc3545;
}

.nomNaissanceCheck label {
  display: block;
  text-align: left;
  margin-bottom: 10px;
}

.nomNaissanceCheck label input {
  vertical-align: middle;
  margin-right: 10px;
}

/* laptops & desktops */
@media (min-width: 1025px) {
  #jeSuisPage {
    margin-top: 3rem;
  }

  .photo-img-row {
    margin-top: 200px;
  }

  .je-suis-class {
    padding: 0 1rem;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  #jeSuisPage {
    margin-top: 3rem;
  }

  .photo-img-row {
    margin-top: 25px;
  }

  .je-suis-class {
    margin: 0 30px;
  }

  .photo-field {
    margin-bottom: 30px;
  }

  .nomNaissanceCheck label {
    margin-bottom: 10px;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  #jeSuisPage {
    margin-top: 1rem;
  }

  .photo-text1,
  .photo-text2,
  .photo-text3 {
    font-size: 13px;
  }

  .photo-img-row {
    margin-top: 25px;
  }

  .fs-file-selector {
    margin-bottom: 20px;
  }

  .photo-field {
    margin-bottom: 30px;
  }

  .je-suis-class {
    margin: 0 30px;
  }

  .file-uploads {
    font-size: 13px;
    margin-top: 20px;
  }

  .form-group {
    font-size: 13px;
  }

  .nomNaissanceCheck label {
    margin-bottom: 10px;
  }
}
</style>
